import { SingleSkuPackageCollection } from "inbounds/createShipment/CreateShipmentTypes";

export const hasInvalidSingleSkuPackages = (singleSkuPackages: SingleSkuPackageCollection): boolean => {
  return Object.values(singleSkuPackages ?? {}).some((skuPackages) => skuPackages.some((pkg) => !pkg.casePackDsku));
};
